import get from 'lodash/get';
import uniqueId from 'lodash/uniqueId';
import actionFactory from '../props/action';
import containerBuilder from './container';
import paddingModifier from '../props/padding-modifier';
import color from '../props/color';
import { BLOCK, TABS_COLOR } from '../const';
import { WEIGHT } from '../../const';

/**
 * Билдер блока div-tabs-block
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-tabs-block.json
 * @param  {Object} block
 * @return {Object}
 */
export default (function (block) {
    var rawItems = block.items;

    if (!rawItems || !rawItems.length) {
        return null;
    }

    var items = rawItems.map(itemBuilder).filter(Boolean);

    if (!items.length) {
        return null;
    }

    return {
        type: block.type,
        hasDelimiter: block.has_delimiter === 1,
        paddingModifier: paddingModifier(block),
        items: items,
        inactiveTabColor: color(block.inactive_tab_color, TABS_COLOR.inactiveTab),
        activeTabColor: color(block.active_tab_color, TABS_COLOR.activeTab),
        activeTabBgColor: color(block.active_tab_bg_color, TABS_COLOR.activeTabBg),
        delimiterColor: color(block.delimiter_color, TABS_COLOR.delimiter),
        id: uniqueId('block_'),
        weight: WEIGHT.tabLineWeight + items[0].weight,
        hasTabs: true
    };
});

var itemBuilder = function itemBuilder(item) {
    var rawContent = item.content;

    if (!rawContent || rawContent.type !== BLOCK.container) {
        return null;
    }

    var content = containerBuilder(rawContent);

    if (!content) {
        return null;
    }

    return {
        content: content,
        title: get(item, 'title.text'),
        action: actionFactory(item),
        weight: content.weight
    };
};